/**
 * Namespace representing different time periods for rankings and statistics.
 * Each period is associated with a unique numeric identifier.
 * @namespace TimePeriodId
 * @description Defines standard time periods used throughout the application for data aggregation and reporting
 */
export namespace TimePeriodId {
  /**
   * Represents the current day period (1 day)
   * @constant
   * @type {bigint}
   */
  export const Today: bigint = 1n;

  /**
   * Represents a three day period (3 days)
   * @constant
   * @type {bigint}
   */
  export const ThreeDays: bigint = 2n;

  /**
   * Represents a one week period (7 days)
   * @constant
   * @type {bigint}
   */
  export const OneWeek: bigint = 3n;

  /**
   * Represents a one month period (30 days)
   * @constant
   * @type {bigint}
   */
  export const OneMonth: bigint = 4n;

  /**
   * Represents a two day period
   * @constant
   * @type {bigint}
   */
  export const TwoDays: bigint = 5n;

  /**
   * Represents a four day period
   * @constant
   * @type {bigint}
   */
  export const FourDays: bigint = 6n;

  /**
   * Represents a five day period
   * @constant
   * @type {bigint}
   */
  export const FiveDays: bigint = 7n;

  /**
   * Represents a six day period
   * @constant
   * @type {bigint}
   */
  export const SixDays: bigint = 8n;

  /**
   * Represents a seven day period
   * @constant
   * @type {bigint}
   */
  export const SevenDays: bigint = 9n;

  /**
   * Represents an eight day period
   * @constant
   * @type {bigint}
   */
  export const EightDays: bigint = 10n;

  /**
   * Represents a nine day period
   * @constant
   * @type {bigint}
   */
  export const NineDays: bigint = 11n;

  /**
   * Represents a ten day period
   * @constant
   * @type {bigint}
   */
  export const TenDays: bigint = 12n;

  /**
   * Represents an eleven day period
   * @constant
   * @type {bigint}
   */
  export const ElevenDays: bigint = 13n;

  /**
   * Represents a twelve day period
   * @constant
   * @type {bigint}
   */
  export const TwelveDays: bigint = 14n;

  /**
   * Represents a thirteen day period
   * @constant
   * @type {bigint}
   */
  export const ThirteenDays: bigint = 15n;

  /**
   * Represents a fourteen day period
   * @constant
   * @type {bigint}
   */
  export const FourteenDays: bigint = 16n;

  /**
   * Represents a fifteen day period
   * @constant
   * @type {bigint}
   */
  export const FifteenDays: bigint = 17n;

  /**
   * Represents a sixteen day period
   * @constant
   * @type {bigint}
   */
  export const SixteenDays: bigint = 18n;

  /**
   * Represents a seventeen day period
   * @constant
   * @type {bigint}
   */
  export const SeventeenDays: bigint = 19n;

  /**
   * Represents an eighteen day period
   * @constant
   * @type {bigint}
   */
  export const EighteenDays: bigint = 20n;

  /**
   * Represents a nineteen day period
   * @constant
   * @type {bigint}
   */
  export const NineteenDays: bigint = 21n;

  /**
   * Represents a twenty day period
   * @constant
   * @type {bigint}
   */
  export const TwentyDays: bigint = 22n;

  /**
   * Represents a twenty-one day period
   * @constant
   * @type {bigint}
   */
  export const TwentyOneDays: bigint = 23n;

  /**
   * Represents a twenty-two day period
   * @constant
   * @type {bigint}
   */
  export const TwentyTwoDays: bigint = 24n;

  /**
   * Represents a twenty-three day period
   * @constant
   * @type {bigint}
   */
  export const TwentyThreeDays: bigint = 25n;

  /**
   * Represents a twenty-four day period
   * @constant
   * @type {bigint}
   */
  export const TwentyFourDays: bigint = 26n;

  /**
   * Represents a twenty-five day period
   * @constant
   * @type {bigint}
   */
  export const TwentyFiveDays: bigint = 27n;

  /**
   * Represents a twenty-six day period
   * @constant
   * @type {bigint}
   */
  export const TwentySixDays: bigint = 28n;

  /**
   * Represents a twenty-seven day period
   * @constant
   * @type {bigint}
   */
  export const TwentySevenDays: bigint = 29n;

  /**
   * Represents a twenty-eight day period
   * @constant
   * @type {bigint}
   */
  export const TwentyEightDays: bigint = 30n;

  /**
   * Represents a twenty-nine day period
   * @constant
   * @type {bigint}
   */
  export const TwentyNineDays: bigint = 31n;

  /**
   * Represents a thirty day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyDays: bigint = 32n;

  /**
   * Represents a thirty-one day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyOneDays: bigint = 33n;

  /**
   * Represents a thirty-two day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyTwoDays: bigint = 34n;

  /**
   * Represents a thirty-three day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyThreeDays: bigint = 35n;

  /**
   * Represents a thirty-four day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyFourDays: bigint = 36n;

  /**
   * Represents a thirty-five day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyFiveDays: bigint = 37n;

  /**
   * Represents a thirty-six day period
   * @constant
   * @type {bigint}
   */
  export const ThirtySixDays: bigint = 38n;

  /**
   * Represents a thirty-seven day period
   * @constant
   * @type {bigint}
   */
  export const ThirtySevenDays: bigint = 39n;

  /**
   * Represents a thirty-eight day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyEightDays: bigint = 40n;

  /**
   * Represents a thirty-nine day period
   * @constant
   * @type {bigint}
   */
  export const ThirtyNineDays: bigint = 41n;

  /**
   * Represents a forty day period
   * @constant
   * @type {bigint}
   */
  export const FortyDays: bigint = 42n;

  /**
   * Represents a forty-one day period
   * @constant
   * @type {bigint}
   */
  export const FortyOneDays: bigint = 43n;

  /**
   * Represents a forty-two day period
   * @constant
   * @type {bigint}
   */
  export const FortyTwoDays: bigint = 44n;

  /**
   * Represents a two month period
   * @constant
   * @type {bigint}
   */
  export const TwoMonths: bigint = 45n;

  /**
   * Represents a three month period
   * @constant
   * @type {bigint}
   */
  export const ThreeMonths: bigint = 46n;

  /**
   * Represents a six month period
   * @constant
   * @type {bigint}
   */
  export const SixMonths: bigint = 47n;

  /**
   * Represents a twelve month period
   * @constant
   * @type {bigint}
   */
  export const TwelveMonths: bigint = 48n;

  /**
   * Represents a twenty-four month period
   * @constant
   * @type {bigint}
   */
  export const TwentyFourMonths: bigint = 49n;

  /**
   * Represents a thirty-six month period
   * @constant
   * @type {bigint}
   */
  export const ThirtySixMonths: bigint = 50n;

  /**
   * Represents a forty-eight month period
   * @constant
   * @type {bigint}
   */
  export const FortyEightMonths: bigint = 51n;

  /**
   * Represents a sixty month period
   * @constant
   * @type {bigint}
   */
  export const SixtyMonths: bigint = 52n;
}

/**
 * Type representing the possible values of TimePeriodId
 * @type {TimePeriodIdType}
 * @description This type is derived from the keys of the TimePeriodId namespace
 */
export type TimePeriodIdType = (typeof TimePeriodId)[keyof typeof TimePeriodId];
